import { nothing } from 'lit';
import { Tabs } from '@outbook/webcomponents-tabs';
import { ModalDialog as Component } from '@outbook/webcomponents-modal-dialog';
import { locale } from '@local/config';

export function Dialog(props) {
  const {
    literals,
    baseId,
    handlers,
    portalWrapperId,
    view = null,
    tabs = []
  } = props;
  // The package's default branch renders Tabs with an undefined `title`, so always supply a view.
  // Forward params (closeDialog) from DialogUi — the wrapper used to drop them.
  const renderView = (params = {}) =>
    view !== null
      ? view(params)
      : tabs.length
        ? Tabs({ items: tabs, isInDialog: true })
        : nothing;

  return Component({
    ...props,
    extraClasses: 'dialog--host',
    literals,
    lang: locale(),
    handlers,
    dialogId: baseId,
    portalWrapperId,
    view: renderView
  });
}

export const ModalDialog = Dialog;
